module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "specialBetsForm"
  }, [_c('div', {
    staticClass: "bet-name"
  }, [_vm._v(_vm._s(this.name))]), _vm._v(" "), _vm._l((_vm.specialBet.inputs), function(bet, index) {
    return _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.bettingSvc.ticket.input[index]),
        expression: "bettingSvc.ticket.input[index]"
      }],
      key: index,
      attrs: {
        "data-index": ("" + index),
        "autocomplete": "off",
        "type": "number",
        "disabled": _vm.isBettingDisabled
      },
      domProps: {
        "value": (_vm.bettingSvc.ticket.input[index])
      },
      on: {
        "keydown": _vm.updated,
        "click": function($event) {
          _vm.setFocus(index)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          var $$exp = _vm.bettingSvc.ticket.input,
            $$idx = index;
          if (!Array.isArray($$exp)) {
            _vm.bettingSvc.ticket.input[index] = $event.target.value
          } else {
            $$exp.splice($$idx, 1, $event.target.value)
          }
        },
        "blur": function($event) {
          _vm.$forceUpdate()
        }
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-020c5e6b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/bets/SpecialBet.vue
// module id = 394
// module chunks = 0